import { Preset } from '@/components/form-components/ListModal'
import { CheckboxRadioField } from '@/modules/templates/types/blueprint'

export const checkboxPresets: Preset<CheckboxRadioField[]>[] = [
  {
    name: 'Basic',
    config: [{ label: 'Item 1' }, { label: 'Item 2' }, { label: 'Item 3' }],
  },
  {
    name: 'COVID 19',
    config: [
      {
        label:
          'I have not been diagnosed with coronavirus (COVID-19) in the last 14 days',
        desiredState: true,
      },
      {
        label:
          'I am not in a period of 14 day quarantine as directed by a health professional',
        desiredState: true,
      },
      {
        label: 'I have not been overseas in the last 14 days',
        desiredState: true,
      },
      {
        label:
          'I have not been in contact with anyone who is currently being tested for coronavirus (COVID-19)',
        desiredState: true,
      },
      {
        label:
          'I do not have anyone in my household who has symptoms consistent with COVID-19',
        desiredState: true,
      },
    ],
  },
]
